import { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import AuthLayout from '@/components/layout/AuthLayout'
import Button from '@/components/ui/Button'
import Input from '@/components/ui/Input'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading] = useState(false)
  const [error, setError] = useState('')
  
  const { signIn, loading: authLoading, error: authError, clearError } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  
  const from = location.state?.from?.pathname || '/dashboard'

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    clearError()

    try {
      await signIn({ email, password, remember: false })
      navigate(from, { replace: true })
    } catch (err) {
      setError('Invalid email or password')
    }
  }

  // Use auth store loading state
  const isLoading = loading || authLoading

  // Show auth store error or local error
  const displayError = error || authError

  return (
    <AuthLayout 
      title="Sign In" 
      subtitle="Enter your credentials to access your account"
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
        {displayError && (
          <div style={{ 
            backgroundColor: '#FEF2F2', 
            border: '1px solid #FECACA', 
            borderRadius: '8px', 
            padding: '12px',
            marginBottom: '16px'
          }}>
            <p style={{ fontSize: '14px', color: 'var(--danger-color)', textAlign: 'center', margin: 0 }}>
              {displayError}
            </p>
          </div>
        )}
        
        <Input
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
        
        <Input
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />
        
        <Button
          type="submit"
          className="w-full"
          loading={isLoading}
        >
          Sign In
        </Button>
        
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px', paddingTop: '16px' }}>
          <span style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
            Don't have an account?{' '}
          </span>
          <Link 
            to="/register" 
            className="link-text"
            style={{ fontSize: '14px' }}
          >
            Create one
          </Link>
        </div>
      </form>
    </AuthLayout>
  )
}